import React from "react";

export const TagImage = ({ type, amount }) => {
	var image = "";
	var tag = ""
	switch (type) {
		case "home":
			image = <img src="media/icons/icon-house.svg" alt="house"/>
			tag = "Homeowners policy(s)"

			break;
		case "collection":
			image = <img src="media/icons/icon-wine.svg" alt="wine"/>
			tag = "Private Collections policy(s)"

			break;
		case "auto":
			image = <img src="media/icons/icon-auto.svg" alt="auto"/>
			tag = "Automobile policy(s)"
			break;
		case "excessFlood":
			image = <img src="media/icons/icon-flood.svg" alt="flood"/>
			tag = "Excess Flood policy(s)"
			break;
		case "excessLiability":
			image = <img src="media/icons/icon-shield.svg" alt="shield"/>
		  tag = "Personal Excess Liability policy(s)"
			break;
		case "earthQuake":
			image = <img src="media/icons/icon-earthquake.svg" alt="earthquake"/>
			tag = "Earthquake policy(s)"
			break;
		default:
			image = ""
			amount = 0
			tag = "Home"
	}
	return <div data-tag-amount={amount} data-tag-type={tag}>
		{image}
	</div>
};



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/TagImage/TagImage.js